import React from 'react';
import { SalesButton } from './SalesButton';
export function FinalCTA() {
  return <section className="py-24 bg-slate-900 text-center px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-6">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-7">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-rose-600/20 rounded-full blur-[100px]" data-id="element-8"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-9">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-10">
          ¿Lista para dejar de ser tu propia enemiga?
        </h2>
        <p className="text-xl text-slate-300 mb-10 leading-relaxed" data-id="element-11">
          Deja de esperar la motivación. Ella no va a venir. Aprende a no
          necesitarla. Recupera tu energía y tu confianza hoy mismo.
        </p>

        <SalesButton className="w-full sm:w-auto text-xl px-12 py-5 shadow-rose-900/50" data-id="element-12">
          SÍ, QUIERO TOMAR EL CONTROL AHORA
        </SalesButton>

        <p className="mt-8 text-slate-500 text-sm" data-id="element-13">
          Tu compra está protegida por nuestra garantía de satisfacción del
          100%.
        </p>
      </div>
    </section>;
}